@if (!timestamp) {
  <div>
    Please select an hour to view from the Consolidated Series Data table on the Audit History tab.
  </div>
}

@if (timestamp) {
  <div>
    <h3>Sub-hourly Audit Data for <b>{{timestamp | stringDate}}</b></h3>
    <series-audit-history-base-table [series]="series" [config]="config"></series-audit-history-base-table>
  </div>
}
